module.exports = __webpack_public_path__ + "static/img/sclw.f3353ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sclw.png
// module id = E2WI
// module chunks = 1